<template>
    <div id="about-us">
        <section class="probootstrap-half">
            <div class="text"  data-aos="fade-up"
                 data-aos-duration="1200"
            >
                <p class="mb10 subtitle">מי אנחנו?</p>
                <h3 class="mt0 mb40">פיתוח בסטנדרט של סטארטאפ</h3>
                <p>מתוך אמונה שהטכנולוגיה שייכת לכולם, החלטנו להיות חברת התוכנה הראשונה שבאמת מנגישה את הטכנולוגיות החדשניות ביותר שעד כה היו שמורות לסטארטאפים וחברות ענק - לכולם!</p>
                <p>אנחנו משתוקקים ליצור עבורכם מערכת יפה, מהירה ודינמית שתחבר את העסק שלכם לטכנולוגיה ותשדר כ"כ 2019.</p>
                <p>בקיצור אנחנו <b>חברה לפיתוח אתרים, מערכות ואפליקציות בסטנדרט של סטארטאפ.</b></p>
                <p class="text-center">
                    <button name="contact-us" v-scroll-to="'#services'" class="btn mb10 to-services">איך אנחנו יכולים לעזור?</button>
                </p>
            </div>
            <div class="image-wrap"  data-aos="fade-up"
                 data-aos-duration="1200"
            >
                <div class="image" style="background-image: url(img/about/technology.svg);"></div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        data (){
            return {
                mobile: window.matchMedia("(max-width:767px)").matches,
            }
        },
        name: 'about',
        methods: {
            handleScroll: function(e) {
                var currentScrollPosition = e.srcElement.scrollTop;
                if (currentScrollPosition > this.scrollPosition) {
                    console.log("Scrolling down");
                }
                this.scrollPosition = currentScrollPosition;
            }
        },
    }
</script>

<style lang="css" scoped>
    .probootstrap-half {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    }
    .probootstrap-half .image-wrap {
        overflow: hidden;
    }
    .probootstrap-half .image-wrap, .probootstrap-half .text {
        width: 50%;
    }
    .probootstrap-half .image {
        width: 100%;
        height: 100%;
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        -webkit-transition: .8s all ease-in-out;
        transition: .8s all ease-in-out;
        background-color: rgb(46, 222, 231);
    }
    .probootstrap-half .text {
        padding: 100px;
        background: #f8f8f8;
    }
    .probootstrap-half .text .subtitle {
        color: #000;
        text-transform: uppercase;
    }
    .probootstrap-half .text p {
        font-size: 18px;
        color: #000;
        line-height: 1.5;
    }
    .mb10 {
        margin-bottom: 10px!important;
    }
    button.to-services {
        background: #bf35d0;
        height: 48px;
        min-width: 185px;
        color: #ffffff;
        font-weight: 500;
        border-radius: 22px 25px 22px 22px;
        cursor: pointer;
    }
    a.to-perpage {
        background: #8ad598;
        height: 48px;
        min-width: 185px;
        color: #ffffff;
        font-weight: 500;
        border-radius: 22px 25px 22px 22px;
        cursor: pointer;
        padding-top: 11px;
    }
    .probootstrap-half .text h3 {
        line-height: 30px;
        font-size: 30px;
        margin-bottom: 30px;
        text-transform: uppercase;
        font-weight: 700;
    }
    .straightDown{
        margin-bottom: -30px;
        margin-top: 30px;
    }
    .straightUp{
        margin-bottom: 30px;
        margin-top: -30px;
    }
    @media screen and (max-width: 1000px) {
        .probootstrap-half .image-wrap {
            height: 400px;
            width: 100%;
        }
        .probootstrap-half .text {
            width: 100%;
            padding: 30px 15px;
            float: left;
        }
        .probootstrap-half .text h3 {
            font-size: 24px;
            line-height: 24px;
        }
    }
</style>